// extracted by mini-css-extract-plugin
export var arrowWrapper = "fd_gp";